import axios from "axios";
import React from "react";

import { Form, Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import BZLogo from "../../components/BZLogo";
import { TwButton, TwMainLayout, TwPhoneInputGroup } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import { useTranslation } from "react-i18next";
import I18nLanguageDropdown from "../../components/I18nLanguageDropdown";

export default function ForgotPassword({ }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const location = useLocation();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);

  React.useEffect(() => {
    if (userToken !== undefined && userToken !== "" && userReduxState.userData?.fullName) {
      window.location.href = "/home/dashboard";
    }
  }, []);

  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <div className="min-h-screen bg-white flex flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="fixed top-5 right-5">
          <I18nLanguageDropdown />
        </div>
        <div className="sm:mx-auto sm:w-full sm:max-w-md flex flex-col gap-5">
          <BZLogo className="mx-auto" />
          {!userToken && (<div className={"flex flex-col justify-center items-center gap-5 md:gap-8"}>
            <h2 className="text-center text-2xl md:text-3xl font-bold tracking-tight">
              {t("forgotPassword.forgotTitle")}
            </h2>
            <p className={"text-base  text-center"}>
              {t("forgotPassword.forgotSubTitle")}
            </p>
          </div>)}
        </div>

        {!userToken && (<div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <Formik
            initialValues={{
              countryName:
                location.state !== null ? location.state.countryName : "nl",
              countryCode:
                location.state !== null ? location.state.countryCode : "",
              phone: location.state !== null ? location.state.number : "",
              formattedPhoneNumber:
                location.state !== null
                  ? location.state.formattedPhoneNumber
                  : "",
            }}
            validate={(values) => {
              const errors = {};

              if (!values.phone) {
                errors.phone = t("errors.required");
              }

              return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {
              dispatch(setActionLoading(true));
              const request = await axios.post(
                `${getUrlForUsers()}forgotPassword`,
                {
                  username: values.countryCode + values.phone,
                  userType: "teacher",
                }
              );
              dispatch(setActionLoading(false));
              if (request.data.statusCode === 200) {
                setSubmitting(false);
                navigate("/forgot-password/verify", {
                  state: {
                    formattedPhoneNumber: values.formattedPhoneNumber,
                    countryName: values.countryName,
                    countryCode: values.countryCode,
                    phone: values.phone,
                    response: request.data,
                  },
                });
              } else {
                setSubmitting(false);
                addErrorToast(request.data.message);
              }
            }}
          >
            {({
              values,
              errors,
              setFieldValue,
              handleBlur,
              submitForm,
              isSubmitting,
            }) => (
              <Form>
                <div className={"flex flex-col gap-4"}>
                  <TwPhoneInputGroup
                    label={t("inputFieldsTitle.phoneNumber")}
                    placeholder={t("inputFieldsTitle.phoneNumber")}
                    name={"phone"}
                    country={values.countryName}
                    onBlur={() => handleBlur("phone")}
                    onChange={(phone, country, e) => {
                      const numberWithoutDialCode = phone.split("");
                      for (let i = 0; i < country.dialCode.length; i++) {
                        numberWithoutDialCode.shift();
                      }
                      let dialCode = country.dialCode;
                      if (
                        country.format.includes("+") &&
                        !country.dialCode.includes("+")
                      ) {
                        dialCode = "+".concat(country.dialCode);
                      }
                      setFieldValue("countryName", country.countryCode);
                      setFieldValue("countryCode", dialCode);
                      setFieldValue("phone", numberWithoutDialCode.join(""));
                      setFieldValue("formattedPhoneNumber", e.target.value);
                    }}
                    errors={errors}
                  />
                  <TwButton
                    variant={"secondary"}
                    onClick={submitForm}
                    disabled={loadingReduxState.actionLoading || isSubmitting}
                    actionLoading={(loadingReduxState.actionLoading)}
                    className="w-full xs:text-base sm:text-xl md:py-3.5"
                    type="submit"
                  >
                    {t("inputFieldsTitle.continue")}
                  </TwButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>)}
      </div>
    </TwMainLayout>)
}
